import { jwtDecode } from 'jwt-decode';
import { InvitationToken, type InvitationTokenKind } from 'models';
import { useMemo } from 'react';

type InvitationTokenPayload = {
  kind?: InvitationTokenKind;
};

export const useEventInviteRole = (invitationToken: string) =>
  useMemo(() => {
    try {
      const { kind } = jwtDecode<InvitationTokenPayload>(invitationToken);

      return kind ? InvitationToken.mapToEventRole[kind] : undefined;
    } catch {
      return undefined;
    }
  }, [invitationToken]);
